import React, { useEffect, useState, useCallback } from 'react';  
import './PropertyListing.css';
import axios from 'axios';
import ConstructionCard from '../../components/ConstructionCard/ConstructonCard';

const PropertyListingPage = ({ filterType, pageTitle }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1); 
  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(true);

  const [search, setSearch] = useState('');
  const [category, setCategory] = useState('');

  const fetchProjects = useCallback(async () => {
    try {
      setLoading(true);
      const res = await axios.get(`https://gladious-constructions.onrender.com/api/properties`, {
        params: {
          page: currentPage,
          limit: 6,
          projectType: filterType || undefined,
          category: category || undefined,
          search: search || undefined,
        }
      });

      const responseData = res.data;
      setProperties(responseData.data || []);
      setTotalPages(responseData.totalPages || 1);
    } catch (err) {
      console.log('Error fetching projects: ' + err.message);
    } finally {
      setLoading(false);
    }
  }, [filterType, currentPage, category, search]);

  useEffect(() => {
    fetchProjects();
  }, [fetchProjects]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [currentPage]);

  const handleCategoryChange = (e) => {
    setCategory(e.target.value);
    setCurrentPage(1);
  };

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
    setCurrentPage(1);
  };

  return (
    <div className="property-listings-container">
      <h2 className="page-title">{pageTitle}</h2>

      <div className="filters-container">
        <div className="search-container">
          <input
            type="text"
            placeholder="Search by title or city"
            value={search}
            onChange={handleSearchChange}
            className="search-input"
          />
        </div>

        <div className="category-filter">
          <select 
            value={category} 
            onChange={handleCategoryChange} 
            className="category-select"
          >
            <option value="">All Categories</option>
            <option value="Residential">Residential</option>
            <option value="Commercial">Commercial</option>
          </select>
        </div>
      </div>

      <div className="cards-grid-container">
<div className={`cards-grid ${loading || properties.length === 0 ? 'centered' : ''}`}>          {loading ? (
                 <div className='property-listing-loading-logo'>
  <img src="/images/logo.png" alt="loading" />
        </div>
          ) : properties.length === 0 ? (
            <div className="no-properties-message">No property available</div>
          ) : (
            properties.map((item) => (
              <ConstructionCard
                key={item._id}
                data={{
                  id: item._id,
                  images: item.images,
                  category: item.category,
                  area: item.area,
                  title: item.title,
                  description: item.description,
                  price: item.price,
                  location: item.location,
                  bedrooms: item.bedrooms || 0,
                  bathrooms: item.bathrooms || 0,
                  email: item.email,
                  phone: item.phone,
                  projectType: item.projectType
                }}
              />
            ))
          )}
        </div>
      </div>

      {totalPages > 1 && (
        <div className="pagination-controls">
          <button
            onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
            className="pagination-button"
          >
            Previous
          </button>

          <span className="pagination-info">
            Page {currentPage} of {totalPages}
          </span>

          <button
            onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
            disabled={currentPage === totalPages}
            className="pagination-button"
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
};

export default PropertyListingPage;
